import React, { useEffect, useState } from 'react';
import { HomeWrapper } from '../../../src/components/HomePage/HomeBanner/styled';
import GlobalStyle from '../../../src/styles/globalStylesV2';
import NewHeader from '../../../src/components/HomePage/NewHeader';
import DueDate from '../../../src/components/DueDate';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import { utilitesFetcher } from '../../../src/datafetchers/HomePage';
import Tools from '../../../src/components/HomePage/Tools';
import {
  getFilteredCategoryContent,
  isAndroidAppUser,
  isIOSAppUser,
} from '../../../src/Utils/helper';
import {
  androidDisablePullRefresh,
  enableAndroidBack,
  hideAndroidBottomBar,
  hideAndroidTopBar,
  useAndroidFetchUserDetails,
} from '../../../src/Utils/androidUtils';
import { iosHideTopBar } from '../../../src/Utils/IosUtils';
import { DueDateCalculatorFooterData } from '../../../src/Constants/SEOStaticData';
import { getSeoVisibility } from '../../../src/appconfig';
import { FAQPageJsonLd, NextSeo } from 'next-seo';
import { revalidate_1_hour } from '../../../src/Utils/SEO/constants';
import { storeDataFetcher } from '../../../src/datafetchers/Store';
import Cookies from 'js-cookie';

export async function getStaticProps() {
  const toolsData = await utilitesFetcher();
  let data = await storeDataFetcher({
    skip: 0,
    limit: 10,
    lang: 'en',
    inApp: false,
    desktopView: true,
    key: 'store',
  });
  return {
    props: {
      tools: toolsData,
      categoryData: getFilteredCategoryContent(data?.data?.categories),
      revalidate: revalidate_1_hour,
    },
  };
}

export default function DueDateCalculator(props) {
  const { tools, categoryData } = props;
  const [hideHamIcon, setShowHamIcon] = useState(false);
  const [showIconForIos, setShowIconForIos] = useState(false);
  const [showExploreTool, setShowExploreTool] = useState(false);
  const [showFooter, setShowFooter] = useState(true);
  const [showHeader, setShowHeader] = useState(false);
  const [hidePaddingForAndroid, setHidePaddingForAndroid] = useState(false);
  const [showVideo, setShowVideo] = useState(true);
  const heading = DueDateCalculatorFooterData.heading;
  const htmlText = DueDateCalculatorFooterData.htmlText;
  const FAQPage = DueDateCalculatorFooterData.faqs;
  const metaTitle = 'Due Date Calculator for Expecting Mothers | MyloFamily';
  const metaDescription =
    'Looking for an accurate and easy way to calculate your due date? Our due date calculator uses the first day of your last menstrual period to estimate your due date, based on the most up-to-date medical research. ';
  const canonicalUrl = 'https://mylofamily.com/tools/duedatecalculator';
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'website',
    locale: 'en',
    url: canonicalUrl,
    images: [
      {
        url: 'https://images.myloapp.in/mydo_upload/mydo_upload_1594374607_263353011.png',
        width: 800,
        height: 800,
      },
    ],
  };

  useEffect(() => {
    if (isAndroidAppUser()) {
      let data = useAndroidFetchUserDetails();
      let androidUserProperties = JSON.parse(data);
      if (androidUserProperties?.guid) {
        Cookies.set('token', androidUserProperties.guid.toString(), '/');
      }

      hideAndroidTopBar();
      enableAndroidBack(true);
      hideAndroidBottomBar();
      androidDisablePullRefresh();
      setShowHamIcon(true);
      setShowExploreTool(false);
      setShowFooter(false);
      setShowHeader('-56px');
      setHidePaddingForAndroid(true);
    }
    if (isIOSAppUser()) {
      window['setUserData'] = function (base64stringifiedJson) {
        let stringifiedJson = window.atob(base64stringifiedJson);
        const userData = JSON.parse(stringifiedJson);
        Cookies.set('token', userData?.guid, {
          expires: 365,
          path: '/',
        });
      };

      iosHideTopBar();
      setShowHamIcon(true);
      setHidePaddingForAndroid(true);
      setShowIconForIos(true);
      setShowHeader('0px');
      setShowVideo(false);
    }
    // } else {
    //     setShowExploreTool(true);
    //     setShowFooter(true);
    //     setShowHeader("0px");
    //     setHidePaddingForAndroid(false);
    // }
  }, []);
  //Provide cumulative sum of tools you want to show on page
  // 0-> Pregnent 1->Mother 2-"ttc"
  const requiredTools = [3, 0, 0];
  return (
    <>
      {getSeoVisibility() ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={openGraphData}
            canonical={canonicalUrl}
          />
          <FAQPageJsonLd mainEntity={FAQPage} />
        </>
      ) : null}
      <GlobalStyle />
      {/* {showHeader ? */}
      {!hideHamIcon && (
        <NewHeader
          hideHamIcon={showIconForIos}
          hideMobileSearch={true}
          hideLogin={true}
          showHeader={showHeader}
          location={'PDP'}
          categoryData={categoryData}
          nostrip={true}
        />
      )}

      {/* : null} */}
      <HomeWrapper hidePaddingForAndroid={hidePaddingForAndroid}>
        <DueDate showVideo={showVideo} stopRedirection={!showFooter} />
        {showExploreTool ? (
          <Tools
            heading={'EXPLORE MORE TOOLS'}
            data={tools?.data}
            gridCount={'4'}
            requiredTools={requiredTools}
            currentToolId={'8'}
          />
        ) : null}
      </HomeWrapper>
      {!hideHamIcon && <NewFooter heading={heading} />}
      {/* <Footer /> */}
    </>
  );
}
